import { IAction } from '~/src/store';

import { EContactAlertActions } from './index';

export type TSetIsFetchingCode = IAction<EContactAlertActions.SET_IS_FETCHING_CODE, boolean>;

const setIsFetchingCode = (status: boolean): TSetIsFetchingCode => ({
    type: EContactAlertActions.SET_IS_FETCHING_CODE,
    payload: status,
});

export default setIsFetchingCode;
